import { unreadCount as styles_unreadCount } from 'owa-mail-listitem-styles/lib/scss/MailListItem.scss';
import classnames from 'owa-classnames';
import { observer } from 'owa-mobx-react';
import {
    type ConditionalFormattingModification,
    getConditionalFormattingStyles,
    ConditionalFormattingSurface,
} from 'owa-conditional-formatting';
import { useMessageListTextStyle } from 'owa-mail-listitem-styles/lib/utils/useMessageListTextStyle';
import React from 'react';

export interface MailListItemUnreadCountProps {
    unreadCount: number;
    conditionalFormattingModifications?: ConditionalFormattingModification[];
    isDarkTheme: boolean;
}

const defaultExport: React.FunctionComponent<MailListItemUnreadCountProps> = observer(
    function MailListItemUnreadCount(props: MailListItemUnreadCountProps): JSX.Element | null {
        const { unreadCount, conditionalFormattingModifications, isDarkTheme } = props;
        const unreadCountConditionalFormattingStyles = React.useMemo(() => {
            const conditionalFormattingStyles =
                conditionalFormattingModifications && conditionalFormattingModifications.length > 0
                    ? getConditionalFormattingStyles(
                          ConditionalFormattingSurface.Text,
                          conditionalFormattingModifications,
                          isDarkTheme
                      )
                    : undefined;

            return conditionalFormattingStyles;
        }, [conditionalFormattingModifications, isDarkTheme]);

        const unreadCountClasses = classnames(styles_unreadCount, useMessageListTextStyle('Major'));

        return unreadCount > 1 ? (
            <span className={unreadCountClasses} style={unreadCountConditionalFormattingStyles}>
                ({unreadCount})
            </span>
        ) : null;
    },
    'MailListItemUnreadCount'
);
export default defaultExport;
